<template>
  <div class="contact-us my-5">
    <section class="container">
      <div class="contact-us__headline">
        <h1>
          Please feel free to contact us for any further information.
        </h1>
      </div>
    </section>
    <div class="contact-us__info">
      <!-- <figure class="mx-auto text-center">
        <img src="@/assets/img/svg/mail.svg" alt="" />
      </figure> -->
      <h2>
        Email Us at:
      </h2>
      <h3>
        <a class="" href="mailto:support@gogocinema.com">support@gogocinema.com</a>
      </h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "contactUs"
};
</script>



// WEBPACK FOOTER //
// src/components/pages/contactUs.vue